
import PageTitle from "../components/common/pageTitle";
import React, { useState, useEffect, useCallback } from "react";
import { CircularProgress, makeStyles, Typography } from "@material-ui/core"
import HomeStyles from '../styles/Home.module.css'
import Polycy from '../components/common/policy-register'
import Breadcrumbs from "../components/common/Breadcrumbs";
import Banner from "../components/common/banner";
import axios from 'axios';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import api from '../libs/utils/axiosApiInstance'
import ConFirmLoginDialog from "../components/common/confirmLogin";

// import CssTextField from '../libs/config/inputConfig';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
// import Button from '@material-ui/core/Button';
// import MenuItem from '@material-ui/core/MenuItem';
// import TextField from '@material-ui/core/TextField';
// import Menu from '@material-ui/core/Menu';
// import axios from 'axios';
// import globalStyle from '../styles/globals.css'
// import HighlightOffIcon from '@material-ui/icons/HighlightOff';
// import ReactLogo from '../assets/icons/pdf.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    margin: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '2rem',
    },
    buttonConfirm: {
        background: '#3364AF',
        fontSize: '1.0rem',
        width: '100%',
        height: '45px',
    },
    buttonUpload: {
        background: '#FBBE66',
        color: '#FFFFFF',
        fontSize: '1.0rem',
        width: '100%',
        height: '54px',
    },

}));

function refreshPage() {
    window.location.reload();
}


export default function ConfirmEmail(props) {
    const query = new URLSearchParams(props.location.search);
    const token = query.get('token');
    const history = useHistory();
    const classes = useStyles();
    let [isLoading, setLoading] = useState(false);
    let [openDialog, setOpenDialog] = useState(false);
    let [email, setEmail] = useState('');
    const [confirm, setConfirm] = useState(0);
    const [earlyToken, setEarlyToken] = useState({
        AccessToken: '',
        RefreshToken: '',
        ExpireDate: '',
        requestNo: ''
    });

    const handleOnLink = () => {

        // history.push('/profile');
        localStorage.setItem('token', earlyToken.AccessToken);
        localStorage.setItem('refreshToken', earlyToken.RefreshToken);
        localStorage.setItem('refreshExpired', earlyToken.ExpireDate);
        localStorage.setItem('requestNo', earlyToken.requestNo);
        // refreshPage();
        setOpenDialog(true)
        
    };

    useEffect(() => {

        if (token) {
            confirmEmail();
        } else {
            setConfirm(0);
        }


    }, []);


    const refreshPage = () => {
        window.location.reload();
    }


    const confirmEmail = async () => {
        setLoading(true)
        const body = {
            Token: token
        }
        const res = await api.post(`/auth/confirm-email`, body);
        const _confirm = res.data.result;
        if (_confirm) {
            const profile = await api.get(`/auth/me`, { headers: { "Authorization": `Bearer ${_confirm.AccessToken}` } });
            const _agentList = profile?.data?.result;
            setEarlyToken({
                AccessToken: _confirm?.AccessToken,
                RefreshToken: _confirm?.RefreshToken,
                ExpireDate: _confirm?.ExpireDate,
                // requestNo: _agentList[_agentList.length - 1].RequestNo
            });
            setEmail(_agentList.Email)
            // const profile = await api.get(`/profile/agents`, { headers: { "Authorization": `Bearer ${_confirm.AccessToken}` } });
            // const _agentList = profile?.data?.result;
            // setEarlyToken({
            //     AccessToken: _confirm?.AccessToken,
            //     RefreshToken: _confirm?.RefreshToken,
            //     ExpireDate: _confirm?.ExpireDate,
            //     requestNo: _agentList[_agentList.length - 1].RequestNo
            // });
            setConfirm(1);
            setLoading(false)
        } else {
            setConfirm(2);
            setLoading(false)
        }

    }



    return (
        <>




            <Banner>
                <div className="container">
                    <PageTitle title="Verification" header="ยืนยันตัวตน" />
                    {/* <Breadcrumbs /> */}
                    <div className="row w-100">
                        <div className="col-md-12" >
                            <div className={HomeStyles.card} >
                                {isLoading ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}><CircularProgress size={100} /> </div> : <>
                                    {confirm === 0 && !token &&
                                        <div className="row">
                                            <div className="col-lg-4 col-md-12">
                                                <div className="text-left pt-3 pb-3">
                                                    <img style={{
                                                        width: '100%'

                                                    }} src='confirmemail.png' alt="confirmemail"></img>
                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-12">
                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center'
                                                }}>
                                                    <Typography variant="h5" className={classes.title} style={{
                                                        marginBottom: '30px',

                                                    }}>
                                                        E-mail Verification
                                                    </Typography>
                                                    <Typography variant="h6" component={'span'} style={{
                                                        marginBottom: '15px',

                                                        color: 'green'
                                                    }}>
                                                        ระบบจะส่งอีเมลไปหาท่าน เพื่อยืนยันตัวตน
                                                    </Typography>
                                                    <Typography variant="h6" component={'span'} style={{
                                                        marginBottom: '15px',

                                                        color: 'green'
                                                    }}>
                                                        ระบบจะทำการส่งข้อมูลอีเมลอีกครั้งหลังจากเจ้าหน้าที่ตรวจสอบข้อมูล กรุณาตรวจสอบอีเมลของท่าน
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {confirm === 1 && token &&
                                        <div className="row">
                                            <div className="col-lg-4 col-md-12">
                                                <div className="text-left pt-3 pb-3">
                                                    <img style={{
                                                        width: '100%'

                                                    }} src='confirmemail.png' alt="confirmemail"></img>
                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-12">
                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center'
                                                }}>
                                                    <Typography variant="h5" className={classes.title} style={{
                                                        marginBottom: '30px',

                                                    }}>
                                                        Complete E-mail Verification
                                                    </Typography>
                                                    <Typography variant="h6" component={'span'} style={{
                                                        marginBottom: '15px',

                                                        color: 'green'
                                                    }}>
                                                        ท่านได้ยืนยันตัวตนสำเร็จแล้ว
                                                    </Typography>


                                                </div>

                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center',
                                                    marginTop: '15px',
                                                    marginBottom: '30px',

                                                }}>
                                                    <Typography variant="h6" component={'span'} style={{

                                                    }}>
                                                        กรุณากด “สร้างรหัสผ่าน” เพื่อเข้าใช้งานระบบ
                                                    </Typography>

                                                </div>
                                                <Button variant="contained" onClick={handleOnLink} className={classes.buttonConfirm} color="primary"
                                                >สร้างรหัสผ่าน</Button>
                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center',
                                                    marginTop: '30px',
                                                }}>
                                                    <Typography variant="h6" component={'span'} style={{
                                                        marginBottom: '15px',

                                                    }}>
                                                        หากพบปัญหาการใช้งานระบบ
                                                    </Typography>

                                                </div>
                                                <div style={{
                                                    marginLeft: '20px',
                                                    marginRight: '20px',
                                                    textAlign: 'center',
                                                    marginBottom: '30px',
                                                }}>
                                                    <Typography component={'span'} style={{
                                                        marginBottom: '15px',

                                                    }}>

                                                        กรุณาติดต่อ กลุ่มบริหารและพัฒนาธุรกิจเมล็ดพันธุ์ กองเมล็ดพันธุ์ข้าว กรมการข้าว โทร 0-2561-3794
                                                    </Typography>

                                                </div>


                                            </div>
                                        </div>
                                    }
                                    {/* {confirm && token &&
                                    <div className="row">
                                        <div className="col-lg-4 col-md-12">
                                            <div className="text-left pt-3 pb-3">
                                                <img style={{
                                                    width: '100%'

                                                }} src='confirmemail.png' alt="confirmemail"></img>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            <div style={{
                                                marginLeft: '100px',
                                                marginRight: '100px',
                                                textAlign: 'center'
                                            }}>
                                                <Typography variant="h5" className={classes.title} style={{
                                                    marginBottom: '30px',

                                                }}>
                                                    Complete E-mail Verification
                                                </Typography>
                                                <Typography variant="h6" component={'span'} style={{
                                                    marginBottom: '15px',

                                                    color: 'green'
                                                }}>
                                                    ท่านได้ยืนยันตัวตนสำเร็จแล้ว
                                                </Typography>
                                           

                                            </div>
                                           
                                            <div style={{
                                                marginLeft: '100px',
                                                marginRight: '100px',
                                                textAlign: 'center'
                                            }}>
                                                <Typography variant="h6" component={'span'} style={{
                                                    marginBottom: '15px',

                                                }}>
                                                    ระบบจะทำการส่งอีเมลอีกครั้งหลังจากเจ้าหน้าที่ตรวจสอบข้อมูล
                                                </Typography>

                                            </div>

                                            <div style={{
                                                marginLeft: '100px',
                                                marginRight: '100px',
                                                textAlign: 'center',
                                                marginBottom: '30px',
                                            }}>
                                                <Typography variant="h6" component={'span'} style={{
                                                    marginBottom: '15px',

                                                }}>
                                                    กรุณาตรวจสอบอีเมลของท่าน
                                                </Typography>

                                            </div>

                                            <Button variant="contained" onClick={handleOnLink} className={classes.buttonConfirm} color="primary"
                                            >เปลี่ยนรหัสผ่าน</Button>
                                        </div>
                                    </div>
                                } */}

                                    {confirm === 2 && token &&
                                        <div className="row">
                                            <div className="col-lg-4 col-md-12">
                                                <div className="text-left pt-3 pb-3">
                                                    <img style={{
                                                        width: '100%'

                                                    }} src='confirmemail.png' alt="confirmemail"></img>
                                                </div>
                                            </div>
                                            <div className="col-lg-8 col-md-12">
                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center'
                                                }}>
                                                    <Typography variant="h5" className={classes.title} style={{
                                                        marginBottom: '30px',

                                                    }}>
                                                        Failed E-mail Verification
                                                    </Typography>
                                                    <Typography variant="h6" component={'span'} style={{
                                                        marginBottom: '15px',

                                                        color: 'red'
                                                    }}>
                                                        การยืนยันอีเมลไม่สำเร็จ    <br/>  กรุณาติดต่อเจ้าหน้าที่
                                                    </Typography>


                                                </div>
                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    marginBottom: '30px',
                                                    textAlign: 'center'
                                                }}>


                                                </div>
                                                {/* <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center'
                                                }}>
                                                    <Typography component={'span'} style={{
                                                        marginBottom: '15px',

                                                    }}>
                                                        ระบบจะทำการส่งอีเมลอีกครั้งหลังจากเจ้าหน้าที่ตรวจสอบข้อมูล
                                                    </Typography>

                                                </div> */}
                                                <div style={{
                                                    marginLeft: '100px',
                                                    marginRight: '100px',
                                                    textAlign: 'center',
                                                    marginBottom: '30px',
                                                }}>
                                                    <Typography component={'span'} style={{
                                                        marginBottom: '15px',

                                                    }}>
                                                        กลุ่มบริหารและพัฒนาธุรกิจเมล็ดพันธุ์ กองเมล็ดพันธุ์ข้าว กรมการข้าว <br/> โทร. 0-2561-3794
                                                    </Typography>

                                                </div>


                                            </div>
                                        </div>
                                    }
                                </>}
                                <ConFirmLoginDialog openPopup={openDialog} email={email} earlyToken={earlyToken}/>
                            </div>

                        </div>
                    </div>

                </div>

            </Banner>










        </>
    )

}

